export default __webpack_public_path__ + "static/media/loading.26e7d4f7.svg";